import { motion, useReducedMotion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 18, className = "", as = "div" }) {
    const reduce = useReducedMotion();
    const MotionTag = motion[as] || motion.div;
    return (
        <MotionTag
            initial={reduce ? { opacity: 0 } : { opacity: 0, y, filter: "blur(6px)" }}
            whileInView={reduce ? { opacity: 1 } : { opacity: 1, y: 0, filter: "blur(0px)" }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
            className={className}
        >
            {children}
        </MotionTag>
    );
}

export function Stagger({ children, className = "", delayChildren = 0.05, staggerChildren = 0.08 }) {
    return (
        <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            variants={{ visible: { transition: { delayChildren, staggerChildren } } }}
            className={className}
        >
            {children}
        </motion.div>
    );
}

export const staggerItem = {
    hidden: { opacity: 0, y: 14 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};
